import { useFeatureFlagEnabled } from 'posthog-js/react';

/** Where this build reaches the Assistant v2 service: REACT_APP_ASSISTANT_URL, else the local service in development. */
export function assistantServiceUrl(): string | null {
  return process.env.REACT_APP_ASSISTANT_URL || (process.env.NODE_ENV === 'development' ? 'http://localhost:8095/api' : null);
}

/**
 * Assistant v2 takes Lodgeic AI's place for this user: the org-gated PostHog
 * flag `assistant-v2` (or REACT_APP_ASSISTANT_V2 in a local build) — and only
 * in a build that knows where the service is. Without the URL the flag does
 * nothing, so turning it on ahead of the service leaves everyone on v1.
 */
export function assistantV2Active(flag: boolean | undefined): boolean {
  return (flag === true || process.env.REACT_APP_ASSISTANT_V2 === 'true') && assistantServiceUrl() != null;
}

export function useAssistantV2Enabled(): boolean {
  return assistantV2Active(useFeatureFlagEnabled('assistant-v2'));
}
